var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgProjectUsersIcon = function SvgProjectUsersIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ELEMENT|ICON|Profile-Vehicle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.06227 7.88431C8.77042 7.88431 10.2125 9.22215 10.2125 10.2364C10.2125 10.8935 8.76117 11.5984 7.06227 11.5984C5.35412 11.5984 3.91211 10.7563 3.91211 10.0694C3.91211 9.05512 5.36295 7.88431 7.06227 7.88431ZM7.06227 3.4707C8.21925 3.4707 9.14669 4.34846 9.14669 5.44347C9.14669 6.53847 8.21925 7.41623 7.06227 7.41623C5.90528 7.41623 4.97785 6.53847 4.97785 5.44347C4.97785 4.34846 5.90528 3.4707 7.06227 3.4707Z",
    stroke: "#6B7785"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 9",
    cx: 6.99097,
    cy: 6.08667,
    r: 5.50854,
    stroke: "#6B7785"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgProjectUsersIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "project-users-icon.93fd8a0a3bc5b46e847ab3f827296bdc.svg";